var _style, _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSocialLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "social_links",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.3;enable-background:new    ;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "container",
    className: "st0",
    cx: 20,
    cy: 20,
    r: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "linkedin",
    className: "st1",
    d: "M13.1,16h3.4v11.3h-3.4V16z M14.7,10.2c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2 C12.7,11.2,13.6,10.2,14.7,10.2L14.7,10.2z M18.4,16h3.3v1.6c0.7-1,1.9-1.7,3.2-1.7h0.9c2.1,0,3.8,1.8,3.8,3.8v1.7v2v3.9h-3.3l0,0 v-1l0,0v-5.1l0,0c0-1.3-0.9-2.3-2.2-2.3l0,0c-1.3,0-2.4,1-2.4,2.3l0,0v4.4v1.7h-3.3V16z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialLinkedin);
export default __webpack_public_path__ + "static/media/social-linkedin.b560c341d9a3cfe7d97f6743c06d96ef.svg";
export { ForwardRef as ReactComponent };